// levels.js
const CONSTANTS = {
    LOBESY_AUDIO: '/mfersbeheaded/audio/voice/lobesy.mp3',
    WRONG_SOUND: '/mfersbeheaded/audio/wrong_sound.mp3',
    GAME_STATE_NOT_YET_BEGUN: 0,
    GAME_STATE_IN_PROGRESS: 1,
    GAME_STATE_COMPLETE: 2,
    N_MFERHEADS: 6,
    N_DEAD_ZONE: 1000,
    BACKEND_URL: "https://pf2s6gyu6d.execute-api.us-west-2.amazonaws.com/default/writeGamePlay"
    //BACKEND_URL: "https://eol08mb249.execute-api.us-west-2.amazonaws.com/default/writeGameplayDev"
};
export function formatDate(dateString) {
    const today = new Date();
    const date = new Date(dateString);

    const diffMs = today - date; // milliseconds difference
    const diffSeconds = diffMs / 1000;
    const diffMinutes = diffSeconds / 60;
    const diffHours = diffMinutes / 60;
    const diffDays = diffHours / 24;

    if (diffMinutes < 5) {
        return 'few minutes ago';
    } else if (diffHours < 1) {
        return 'last hour';
    } else if (diffHours < 6) {
        return 'a few hours ago';
    } else if (diffDays < 1) {
        return 'today';
    } else if (diffDays < 2) {
        return 'yesterday';
    } else if (diffDays < 7) {
        return `${Math.floor(diffDays)} days ago`;
    } else if (diffDays < 14) {
        return 'last week';
    } else if (diffDays < 30) {
        return `${Math.floor(diffDays / 7)} weeks ago`;
    } else if (diffDays < 60) {
        return 'last month';
    } else {
        // Return the actual date for anything older than 2 months
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}/${month}/${day}`;
    }
}
export function computeBasedness(totalScore, levelName) {
    if (levelName === "Let's F'ing Rawr") {
        if (totalScore > 2000) {
            return ["rawrizard", "/mfersbeheaded/images/tinydinos/charizard.png"];
        } else if (totalScore > 690) {
            return ["Noun Dino spartan", "/mfersbeheaded/images/tinydinos/nouns.png"];
        } else if (totalScore >= 450) {
            return ["Rainbow Dino", '/mfersbeheaded/images/tinydinos/rainbowDino.png'];
        } else if (totalScore >= 350) {
            return ["Mfer Dino", '/mfersbeheaded/images/tinydinos/mfer.png'];
        } else if (totalScore >= 200) {
            return ["Bat Dino", '/mfersbeheaded/images/tinydinos/bug.png'];
        } else {
            return ["Dino", '/mfersbeheaded/images/tinydinos/skater.png'];
        }
    }
    if (levelName === "Pixel Crush") {
        if (totalScore > 2000) {
            return ["king spartan", "/mfersbeheaded/images/naka/nakaking.png"];
        } else if (totalScore > 690) {
            return ["king spartan", "/mfersbeheaded/images/naka/nakaking.png"];
        } else if (totalScore >= 450) {
            return ["hoodie", '/mfersbeheaded/images/naka/naka10043.png'];
        } else if (totalScore >= 350) {
            return ["frog", '/mfersbeheaded/images/naka/naka6219.png'];
        } else if (totalScore >= 200) {
            return ["bot", '/mfersbeheaded/images/naka/naka1514.png'];
        } else {
            return ["migo", '/mfersbeheaded/images/naka/naka16327.png'];
        }
    }
    if (totalScore > 2000) {
        return ["alien", '/mfersbeheaded/images/fullbody/alien.png'];
    } else if (totalScore > 690) {
        return ["ape", '/mfersbeheaded/images/fullbody/ape.png'];
    } else if (totalScore >= 450) {
        return ["zombie", '/mfersbeheaded/images/fullbody/zombie.png'];
    } else if (totalScore >= 350) {
        return ["hoodie", '/mfersbeheaded/images/fullbody/hoodie.png'];
    } else if (totalScore >= 200) {
        return ["cowboy", '/mfersbeheaded/images/fullbody/cowboy.png'];
    } else {
        return ["mfer", '/mfersbeheaded/images/fullbody/mfer.png'];
    }
}

export default CONSTANTS;
  